module.exports = __webpack_public_path__ + "static/pocketbits-color-90f53d8b81f066be3fa04760be8797ec.webp";